/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { createHelpPage } from '../fn/admin-help-api/create-help-page';
import { CreateHelpPage$Params } from '../fn/admin-help-api/create-help-page';
import { createLocalization } from '../fn/admin-help-api/create-localization';
import { CreateLocalization$Params } from '../fn/admin-help-api/create-localization';
import { createRoute } from '../fn/admin-help-api/create-route';
import { CreateRoute$Params } from '../fn/admin-help-api/create-route';
import { deleteHelpPage } from '../fn/admin-help-api/delete-help-page';
import { DeleteHelpPage$Params } from '../fn/admin-help-api/delete-help-page';
import { deleteLocalization } from '../fn/admin-help-api/delete-localization';
import { DeleteLocalization$Params } from '../fn/admin-help-api/delete-localization';
import { deleteRoute } from '../fn/admin-help-api/delete-route';
import { DeleteRoute$Params } from '../fn/admin-help-api/delete-route';
import { getAllHelpPages } from '../fn/admin-help-api/get-all-help-pages';
import { GetAllHelpPages$Params } from '../fn/admin-help-api/get-all-help-pages';
import { getAllRoutes } from '../fn/admin-help-api/get-all-routes';
import { GetAllRoutes$Params } from '../fn/admin-help-api/get-all-routes';
import { getHelpPage1 } from '../fn/admin-help-api/get-help-page-1';
import { GetHelpPage1$Params } from '../fn/admin-help-api/get-help-page-1';
import { getHelpPageLocalizations } from '../fn/admin-help-api/get-help-page-localizations';
import { GetHelpPageLocalizations$Params } from '../fn/admin-help-api/get-help-page-localizations';
import { getHelpPageRoutes } from '../fn/admin-help-api/get-help-page-routes';
import { GetHelpPageRoutes$Params } from '../fn/admin-help-api/get-help-page-routes';
import { getHelpPageTagCloud1 } from '../fn/admin-help-api/get-help-page-tag-cloud-1';
import { GetHelpPageTagCloud1$Params } from '../fn/admin-help-api/get-help-page-tag-cloud-1';
import { getLocalization } from '../fn/admin-help-api/get-localization';
import { GetLocalization$Params } from '../fn/admin-help-api/get-localization';
import { getRoute } from '../fn/admin-help-api/get-route';
import { GetRoute$Params } from '../fn/admin-help-api/get-route';
import { HelpLocalizationDto } from '../models/help-localization-dto';
import { HelpPageDto } from '../models/help-page-dto';
import { HelpRouteDto } from '../models/help-route-dto';
import { PageDtoHelpPageHelpPageDto } from '../models/page-dto-help-page-help-page-dto';
import { PageDtoHelpRouteHelpRouteDto } from '../models/page-dto-help-route-help-route-dto';
import { SimpleList } from '../models/simple-list';
import { updateHelpPage } from '../fn/admin-help-api/update-help-page';
import { UpdateHelpPage$Params } from '../fn/admin-help-api/update-help-page';
import { updateLocalization } from '../fn/admin-help-api/update-localization';
import { UpdateLocalization$Params } from '../fn/admin-help-api/update-localization';
import { updateRoute } from '../fn/admin-help-api/update-route';
import { UpdateRoute$Params } from '../fn/admin-help-api/update-route';

@Injectable({ providedIn: 'root' })
export class AdminHelpApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getRoute()` */
  static readonly GetRoutePath = '/api/admin/help/routes/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getRoute()` instead.
   *
   * This method doesn't expect any request body.
   */
  getRoute$Response(params: GetRoute$Params, context?: HttpContext): Observable<StrictHttpResponse<HelpRouteDto>> {
    return getRoute(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getRoute$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getRoute(params: GetRoute$Params, context?: HttpContext): Observable<HelpRouteDto> {
    return this.getRoute$Response(params, context).pipe(
      map((r: StrictHttpResponse<HelpRouteDto>): HelpRouteDto => r.body)
    );
  }

  /** Path part for operation `updateRoute()` */
  static readonly UpdateRoutePath = '/api/admin/help/routes/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateRoute()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateRoute$Response(params: UpdateRoute$Params, context?: HttpContext): Observable<StrictHttpResponse<HelpRouteDto>> {
    return updateRoute(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateRoute$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateRoute(params: UpdateRoute$Params, context?: HttpContext): Observable<HelpRouteDto> {
    return this.updateRoute$Response(params, context).pipe(
      map((r: StrictHttpResponse<HelpRouteDto>): HelpRouteDto => r.body)
    );
  }

  /** Path part for operation `deleteRoute()` */
  static readonly DeleteRoutePath = '/api/admin/help/routes/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteRoute()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteRoute$Response(params: DeleteRoute$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteRoute(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteRoute$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteRoute(params: DeleteRoute$Params, context?: HttpContext): Observable<void> {
    return this.deleteRoute$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getHelpPage1()` */
  static readonly GetHelpPage1Path = '/api/admin/help/pages/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getHelpPage1()` instead.
   *
   * This method doesn't expect any request body.
   */
  getHelpPage1$Response(params: GetHelpPage1$Params, context?: HttpContext): Observable<StrictHttpResponse<HelpPageDto>> {
    return getHelpPage1(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getHelpPage1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getHelpPage1(params: GetHelpPage1$Params, context?: HttpContext): Observable<HelpPageDto> {
    return this.getHelpPage1$Response(params, context).pipe(
      map((r: StrictHttpResponse<HelpPageDto>): HelpPageDto => r.body)
    );
  }

  /** Path part for operation `updateHelpPage()` */
  static readonly UpdateHelpPagePath = '/api/admin/help/pages/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateHelpPage()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateHelpPage$Response(params: UpdateHelpPage$Params, context?: HttpContext): Observable<StrictHttpResponse<HelpPageDto>> {
    return updateHelpPage(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateHelpPage$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateHelpPage(params: UpdateHelpPage$Params, context?: HttpContext): Observable<HelpPageDto> {
    return this.updateHelpPage$Response(params, context).pipe(
      map((r: StrictHttpResponse<HelpPageDto>): HelpPageDto => r.body)
    );
  }

  /** Path part for operation `deleteHelpPage()` */
  static readonly DeleteHelpPagePath = '/api/admin/help/pages/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteHelpPage()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteHelpPage$Response(params: DeleteHelpPage$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteHelpPage(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteHelpPage$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteHelpPage(params: DeleteHelpPage$Params, context?: HttpContext): Observable<void> {
    return this.deleteHelpPage$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getLocalization()` */
  static readonly GetLocalizationPath = '/api/admin/help/localizations/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getLocalization()` instead.
   *
   * This method doesn't expect any request body.
   */
  getLocalization$Response(params: GetLocalization$Params, context?: HttpContext): Observable<StrictHttpResponse<HelpLocalizationDto>> {
    return getLocalization(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getLocalization$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getLocalization(params: GetLocalization$Params, context?: HttpContext): Observable<HelpLocalizationDto> {
    return this.getLocalization$Response(params, context).pipe(
      map((r: StrictHttpResponse<HelpLocalizationDto>): HelpLocalizationDto => r.body)
    );
  }

  /** Path part for operation `updateLocalization()` */
  static readonly UpdateLocalizationPath = '/api/admin/help/localizations/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateLocalization()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateLocalization$Response(params: UpdateLocalization$Params, context?: HttpContext): Observable<StrictHttpResponse<HelpLocalizationDto>> {
    return updateLocalization(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateLocalization$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateLocalization(params: UpdateLocalization$Params, context?: HttpContext): Observable<HelpLocalizationDto> {
    return this.updateLocalization$Response(params, context).pipe(
      map((r: StrictHttpResponse<HelpLocalizationDto>): HelpLocalizationDto => r.body)
    );
  }

  /** Path part for operation `deleteLocalization()` */
  static readonly DeleteLocalizationPath = '/api/admin/help/localizations/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteLocalization()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteLocalization$Response(params: DeleteLocalization$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteLocalization(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteLocalization$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteLocalization(params: DeleteLocalization$Params, context?: HttpContext): Observable<void> {
    return this.deleteLocalization$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getAllHelpPages()` */
  static readonly GetAllHelpPagesPath = '/api/admin/help/pages';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAllHelpPages()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllHelpPages$Response(params: GetAllHelpPages$Params, context?: HttpContext): Observable<StrictHttpResponse<PageDtoHelpPageHelpPageDto>> {
    return getAllHelpPages(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAllHelpPages$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllHelpPages(params: GetAllHelpPages$Params, context?: HttpContext): Observable<PageDtoHelpPageHelpPageDto> {
    return this.getAllHelpPages$Response(params, context).pipe(
      map((r: StrictHttpResponse<PageDtoHelpPageHelpPageDto>): PageDtoHelpPageHelpPageDto => r.body)
    );
  }

  /** Path part for operation `createHelpPage()` */
  static readonly CreateHelpPagePath = '/api/admin/help/pages';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createHelpPage()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createHelpPage$Response(params: CreateHelpPage$Params, context?: HttpContext): Observable<StrictHttpResponse<HelpPageDto>> {
    return createHelpPage(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createHelpPage$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createHelpPage(params: CreateHelpPage$Params, context?: HttpContext): Observable<HelpPageDto> {
    return this.createHelpPage$Response(params, context).pipe(
      map((r: StrictHttpResponse<HelpPageDto>): HelpPageDto => r.body)
    );
  }

  /** Path part for operation `getHelpPageRoutes()` */
  static readonly GetHelpPageRoutesPath = '/api/admin/help/pages/{id}/routes';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getHelpPageRoutes()` instead.
   *
   * This method doesn't expect any request body.
   */
  getHelpPageRoutes$Response(params: GetHelpPageRoutes$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<HelpRouteDto>>> {
    return getHelpPageRoutes(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getHelpPageRoutes$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getHelpPageRoutes(params: GetHelpPageRoutes$Params, context?: HttpContext): Observable<Array<HelpRouteDto>> {
    return this.getHelpPageRoutes$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<HelpRouteDto>>): Array<HelpRouteDto> => r.body)
    );
  }

  /** Path part for operation `createRoute()` */
  static readonly CreateRoutePath = '/api/admin/help/pages/{id}/routes';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createRoute()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createRoute$Response(params: CreateRoute$Params, context?: HttpContext): Observable<StrictHttpResponse<HelpRouteDto>> {
    return createRoute(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createRoute$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createRoute(params: CreateRoute$Params, context?: HttpContext): Observable<HelpRouteDto> {
    return this.createRoute$Response(params, context).pipe(
      map((r: StrictHttpResponse<HelpRouteDto>): HelpRouteDto => r.body)
    );
  }

  /** Path part for operation `getHelpPageLocalizations()` */
  static readonly GetHelpPageLocalizationsPath = '/api/admin/help/pages/{id}/localizations';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getHelpPageLocalizations()` instead.
   *
   * This method doesn't expect any request body.
   */
  getHelpPageLocalizations$Response(params: GetHelpPageLocalizations$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<HelpLocalizationDto>>> {
    return getHelpPageLocalizations(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getHelpPageLocalizations$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getHelpPageLocalizations(params: GetHelpPageLocalizations$Params, context?: HttpContext): Observable<Array<HelpLocalizationDto>> {
    return this.getHelpPageLocalizations$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<HelpLocalizationDto>>): Array<HelpLocalizationDto> => r.body)
    );
  }

  /** Path part for operation `createLocalization()` */
  static readonly CreateLocalizationPath = '/api/admin/help/pages/{id}/localizations';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createLocalization()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createLocalization$Response(params: CreateLocalization$Params, context?: HttpContext): Observable<StrictHttpResponse<HelpLocalizationDto>> {
    return createLocalization(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createLocalization$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createLocalization(params: CreateLocalization$Params, context?: HttpContext): Observable<HelpLocalizationDto> {
    return this.createLocalization$Response(params, context).pipe(
      map((r: StrictHttpResponse<HelpLocalizationDto>): HelpLocalizationDto => r.body)
    );
  }

  /** Path part for operation `getHelpPageTagCloud1()` */
  static readonly GetHelpPageTagCloud1Path = '/api/admin/help/tags';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getHelpPageTagCloud1()` instead.
   *
   * This method doesn't expect any request body.
   */
  getHelpPageTagCloud1$Response(params?: GetHelpPageTagCloud1$Params, context?: HttpContext): Observable<StrictHttpResponse<SimpleList>> {
    return getHelpPageTagCloud1(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getHelpPageTagCloud1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getHelpPageTagCloud1(params?: GetHelpPageTagCloud1$Params, context?: HttpContext): Observable<SimpleList> {
    return this.getHelpPageTagCloud1$Response(params, context).pipe(
      map((r: StrictHttpResponse<SimpleList>): SimpleList => r.body)
    );
  }

  /** Path part for operation `getAllRoutes()` */
  static readonly GetAllRoutesPath = '/api/admin/help/routes';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAllRoutes()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllRoutes$Response(params: GetAllRoutes$Params, context?: HttpContext): Observable<StrictHttpResponse<PageDtoHelpRouteHelpRouteDto>> {
    return getAllRoutes(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAllRoutes$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllRoutes(params: GetAllRoutes$Params, context?: HttpContext): Observable<PageDtoHelpRouteHelpRouteDto> {
    return this.getAllRoutes$Response(params, context).pipe(
      map((r: StrictHttpResponse<PageDtoHelpRouteHelpRouteDto>): PageDtoHelpRouteHelpRouteDto => r.body)
    );
  }

}
